import { useMemo } from 'react';

import type { ProfileData } from '@/apis/settings';
import { useToken } from '@/common/helper';
import { userCanShowNoTeamFilter } from '@/common/utils/noTeamFilter';
import { useProfileQuery } from '@/hooks/useProfileQuery';

function profileTeamsFromQuery(
  profileQueryData: ReturnType<typeof useProfileQuery>['data']
): ProfileData['teams'] | undefined {
  const inner = profileQueryData?.data?.data;
  if (!inner?.is_success) return undefined;
  return inner.data?.teams;
}

/**
 * Matches backend untagged gate: Default-team users and company owners.
 */
export function useCanShowNoTeamFilter(): boolean {
  const { decodedUserToken, token } = useToken();
  const { data: profileQueryData } = useProfileQuery();

  return useMemo(() => {
    // `token` is the reactive auth signal; decodedUserToken() reads localStorage.
    const decoded = token ? decodedUserToken() : null;
    return userCanShowNoTeamFilter(
      decoded?.is_company_owner === true,
      profileTeamsFromQuery(profileQueryData)
    );
  }, [token, decodedUserToken, profileQueryData]);
}
